@if (contentLoaded) {
	<div class="container">
		<div class="row mb-4">
			<!-- <h1 class="mb-5">{{content.title}}</h1> -->
			<div id="introduction" [innerHTML]="content.introduction"></div>
		</div>
		<div class="row mb-4">
			@if (this.content.linkAccordion) {
				<div class="col-lg-8 col-md-8 col-sm-12 col-12">
					<app-main-menu [links]="content.mainMenuButtons"></app-main-menu>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-12 col-12">
					<app-multi-link-accordion [accordion]="content.linkAccordion"></app-multi-link-accordion>
				</div>
			} @else {
				<h2 class="mb-3">Servizi Online</h2>
				<div class="col-12">
					<app-main-menu [links]="content.mainMenuButtons"></app-main-menu>
				</div>
			}
		</div>
		<div class="row mb-4">
			@if (content.contenutiCorrelati && content.contenutiCorrelati.length > 0) {
				<h2 class="mb-3">Contenuti correlati</h2>
				<div class="col">
					<app-contenuti-correlati
						[contenutiCorrelati]="content.contenutiCorrelati"></app-contenuti-correlati>
				</div>
			}
		</div>
	</div>
} @else if (showPageError) {
	<app-page-error></app-page-error>
} @else {
	<app-loading-spinner></app-loading-spinner>
}
